'use client';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import { ButtonFragmentFragment } from '@fm-nx/contentful-types';
import { StickyButton } from '../sticky-button/sticky-button';
import { Button } from '../button/button';
import Breadcrumb from '../breadcrumb/breadcrumb';

type PageIntroLevel0DisplayProps = {
    entryId?: string;
    title?: string | null;
    headerText?: string | null;
    headerParagraph?: string | null;
    button?: ButtonFragmentFragment | null;
};

export const PageIntroLevel0Display = (props: PageIntroLevel0DisplayProps) => {
    const { headerText, headerParagraph, button, entryId, title } = props;
    const inspectorProps = useContentfulInspectorMode({ entryId });

    return (
        <div
            className="rounded-b-(--radius-fluid-lg) pt-32 pb-2 md:pt-40 lg:pt-48 md:pb-20"
            style={{
                background:
                    'radial-gradient(227.37% 169.44% at 90.22% 79.74%, #043C32 0%, #5F7235 49.58%, #B1AC37 100%)',
            }}
        >
            <div className="relative w-full mx-auto max-w-container">
                <div className={'mx-6 md:mx-0 grid grid-cols-1 gap-4 md:grid-cols-14'}>
                    <div className={'space-y-6 md:col-span-9 md:col-start-2 lg:col-start-2'}>
                        <Breadcrumb title={title} />
                        <h2
                            {...inspectorProps({
                                fieldId: 'title',
                            })}
                            className={'h-4xl text-white'}
                        >
                            {headerText}
                        </h2>
                        {headerParagraph && (
                            <p
                                {...inspectorProps({
                                    fieldId: 'summary',
                                })}
                                className={'h-md md:h-lg text-white'}
                            >
                                {headerParagraph}
                            </p>
                        )}

                        <div className="md:hidden">
                            {/* Hidden at md because StickyButton replaces it */}
                            {button && <Button button={button} />}
                        </div>

                        {button && (
                            <div className="hidden md:block absolute z-40 right-8 md:right-16 bottom-0">
                                <StickyButton button={button} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PageIntroLevel0Display;
